import React from 'react'

const BtnLoader = () => {
    return (
        <div
            class="spinner-border text-light"
            role="status"
            style={{
                marginTop: "5px",
                width: "0.9rem",
                height: "0.9rem",
            }}
        ></div>
    )
}

export default BtnLoader